var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "11.5 11.5 27.5 27.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-guidelines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    transform: "translate(-668.000000, -655.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Change-status",
    transform: "translate(668.000000, 655.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    transform: "translate(11.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "svg-stroke",
    id: "Rectangle",
    x: 1.5,
    y: 3.5,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-stroke",
    id: "Group-2",
    transform: "translate(3.000000, 6.000000)",
    strokeLinecap: "square",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,3 L2.5,5",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0 L7,4.5",
    id: "Line-2",
    transform: "translate(5.000000, 2.500000) scale(-1, 1) translate(-5.000000, -2.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    className: "svg-stroke",
    id: "Group",
    transform: "translate(19.000000, 21.000000)",
    strokeLinecap: "square",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.71702669e-13,-2.93098879e-14 L6.18718434,6.18718434",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.71702669e-13,-2.93098879e-14 L6.18718434,6.18718434",
    id: "Line",
    transform: "translate(3.093592, 3.093592) scale(-1, 1) translate(-3.093592, -3.093592) "
  })), /*#__PURE__*/React.createElement("rect", {
    className: "svg-stroke",
    id: "Rectangle",
    x: 16.5,
    y: 18.5,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M1.39441832,21 L2.26438104,21.3565777 L1.39264258,25.1994079 C4.67219936,23.0173944 7.4381733,22.7895264 9.52107249,23.3175392 C11.7282977,23.8724332 13.1498273,25.2337661 13.7181519,25.8653876 C13.8965812,26.064416 13.9907434,26.1927697 14,26.2045191 L13.2811755,26.8576812 C13.2811755,26.8576812 13.280218,26.8567911 13.2722381,26.8461098 C13.2478198,26.8140659 13.1769588,26.7243429 13.062049,26.5963452 C12.5733633,26.0494621 11.2847779,24.8180852 9.31758644,24.3262108 C7.45636735,23.8629981 4.97064557,24.0242858 1.84940892,26.1003764 L5.10092508,27.0320953 L4.77375142,28 L0,26.4268684 L1.39441832,21 Z",
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(7.000000, 24.500000) scale(-1, 1) rotate(126.000000) translate(-7.000000, -24.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M16.3944183,5 L17.264381,5.35657772 L16.3926426,9.19940791 C19.6721994,7.01739438 22.4381733,6.78952644 24.5210725,7.31753918 C26.7282977,7.87243321 28.1498273,9.23376612 28.7181519,9.86538756 C28.8965812,10.064416 28.9907434,10.1927697 29,10.2045191 L28.2811755,10.8576812 C28.2811755,10.8576812 28.280218,10.8567911 28.2722381,10.8461098 C28.2478198,10.8140659 28.1769588,10.7243429 28.062049,10.5963452 C27.5733633,10.0494621 26.2847779,8.81808515 24.3175864,8.32621085 C22.4563673,7.86299806 19.9706456,8.02428583 16.8494089,10.1003764 L20.1009251,11.0320953 L19.7737514,12 L15,10.4268684 L16.3944183,5 Z",
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(22.000000, 8.500000) scale(1, -1) rotate(126.000000) translate(-22.000000, -8.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStatus);
export default __webpack_public_path__ + "static/media/change-status.313ad75c39532261392661174daf7640.svg";
export { ForwardRef as ReactComponent };